import { Button, Icon, Text, View } from "@/components"
import { FilePreview } from './FilePreview'

export const FileInputArea = ({ onPress }) => {
  return (
    <FilePreview.Wrapper onClick={onPress}>
      <View style={['row', 'gap:1', 'center', 'fullWidth']}>
        <Icon name='upload-3-line' style={['size:3']} />
        
        <Text
          text={'Upload image (optional)'}
          style={['p3', 'medium', 'ellipsis']}
        />
      </View>
    </FilePreview.Wrapper>
  )
}